// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Horizontal Scroll Arrows - Exact styling from old lobby */
:root {
  --scroll-arrow-width: 100px;
  --scroll-arrow-height: 80px;
  --scroll-arrow-circle-width: 40px;
}
.W179z6znr26JSdfkd3JQ,
.BzHGuXKKzzLCLnWxUD8X {
  position: absolute;
  width: var(--scroll-arrow-width);
  height: var(--scroll-arrow-height);
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
  z-index: 30;
  pointer-events: auto;
}
@media (max-width: 800px) {
  .W179z6znr26JSdfkd3JQ,
  .BzHGuXKKzzLCLnWxUD8X {
    width: 70px;
    height: 60px;
  }
}
/* fallow-ignore-next-line unused-export */
.egt_react_lobby_mobile .W179z6znr26JSdfkd3JQ,
.egt_react_lobby_mobile .BzHGuXKKzzLCLnWxUD8X {
  display: none;
}
.BzHGuXKKzzLCLnWxUD8X {
  right: 0;
  border-radius: 50px 0 0 50px;
}
.W179z6znr26JSdfkd3JQ {
  left: 0;
  border-radius: 0 50px 50px 0;
}
.TJ6MlsD2qK_vhIFzrPSF {
  justify-content: center;
  align-items: center;
  cursor: pointer;
  display: flex;
  align-self: center;
  width: var(--scroll-arrow-circle-width);
  height: var(--scroll-arrow-circle-width);
  background-color: var(--white-color);
  border-radius: 50%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  z-index: 30;
  pointer-events: none;
}
@media (max-width: 800px) {
  .TJ6MlsD2qK_vhIFzrPSF {
    width: 30px;
    height: 30px;
  }
}
.BzHGuXKKzzLCLnWxUD8X .TJ6MlsD2qK_vhIFzrPSF {
  right: 0;
  margin-left: 30%;
}
.W179z6znr26JSdfkd3JQ .TJ6MlsD2qK_vhIFzrPSF {
  left: 0;
  margin-left: 32%;
}
.EHcRb2TPdcujkvK1HsDG {
  width: 16px;
  height: 16px;
  color: var(--dark-grey);
  pointer-events: none;
  display: block;
  margin: auto;
}
.BzHGuXKKzzLCLnWxUD8X .EHcRb2TPdcujkvK1HsDG {
  transform: rotate(-90deg);
}
.W179z6znr26JSdfkd3JQ .EHcRb2TPdcujkvK1HsDG {
  transform: rotate(90deg);
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Section/ScrollArrows/ScrollArrows.module.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;EAClC,oCAAoC;EACpC,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;AACtB;AACA;EACE;;IAEE,WAAW;IACX,YAAY;EACd;AACF;AACA,0CAA0C;AAC1C;;EAEE,aAAa;AACf;AACA;EACE,QAAQ;EACR,4BAA4B;AAC9B;AACA;EACE,OAAO;EACP,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,wCAAwC;EACxC,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;AACtB;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B","sourcesContent":["/* Horizontal Scroll Arrows - Exact styling from old lobby */\n:root {\n  --scroll-arrow-width: 100px;\n  --scroll-arrow-height: 80px;\n  --scroll-arrow-circle-width: 40px;\n}\n.leftScrollArrow,\n.rightScrollArrow {\n  position: absolute;\n  width: var(--scroll-arrow-width);\n  height: var(--scroll-arrow-height);\n  background-color: rgba(0, 0, 0, 0.4);\n  cursor: pointer;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 30;\n  pointer-events: auto;\n}\n@media (max-width: 800px) {\n  .leftScrollArrow,\n  .rightScrollArrow {\n    width: 70px;\n    height: 60px;\n  }\n}\n/* fallow-ignore-next-line unused-export */\n:global(.egt_react_lobby_mobile) .leftScrollArrow,\n:global(.egt_react_lobby_mobile) .rightScrollArrow {\n  display: none;\n}\n.rightScrollArrow {\n  right: 0;\n  border-radius: 50px 0 0 50px;\n}\n.leftScrollArrow {\n  left: 0;\n  border-radius: 0 50px 50px 0;\n}\n.scrollArrowIcon {\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  align-self: center;\n  width: var(--scroll-arrow-circle-width);\n  height: var(--scroll-arrow-circle-width);\n  background-color: var(--white-color);\n  border-radius: 50%;\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 30;\n  pointer-events: none;\n}\n@media (max-width: 800px) {\n  .scrollArrowIcon {\n    width: 30px;\n    height: 30px;\n  }\n}\n.rightScrollArrow .scrollArrowIcon {\n  right: 0;\n  margin-left: 30%;\n}\n.leftScrollArrow .scrollArrowIcon {\n  left: 0;\n  margin-left: 32%;\n}\n.scrollArrowSvg {\n  width: 16px;\n  height: 16px;\n  color: var(--dark-grey);\n  pointer-events: none;\n  display: block;\n  margin: auto;\n}\n.rightScrollArrow .scrollArrowSvg {\n  transform: rotate(-90deg);\n}\n.leftScrollArrow .scrollArrowSvg {\n  transform: rotate(90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftScrollArrow": `W179z6znr26JSdfkd3JQ`,
	"rightScrollArrow": `BzHGuXKKzzLCLnWxUD8X`,
	"scrollArrowIcon": `TJ6MlsD2qK_vhIFzrPSF`,
	"scrollArrowSvg": `EHcRb2TPdcujkvK1HsDG`
};
export default ___CSS_LOADER_EXPORT___;
